import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import HeroSection from './HeroSection';
import OurStorySection from './OurStorySection';
import HowItWorksSection from './HowItWorksSection';
import CustomersSection from './CustomersSection';
import BusinessesSection from './BusinessesSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <HeroSection />

      {/* Our Story Section */}
      <OurStorySection />

      {/* How it Works Section */}
      <HowItWorksSection />

      {/* Customers Section */}
      <CustomersSection />

      {/* Businesses Section */}
      <BusinessesSection />

      <Footer />
    </div>
  );
};

export default HomePage;
